var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9165 3.50033H12.8332V4.66699H11.6665V12.2503C11.6665 12.405 11.605 12.5534 11.4956 12.6628C11.3863 12.7722 11.2379 12.8337 11.0832 12.8337H2.9165C2.76179 12.8337 2.61342 12.7722 2.50403 12.6628C2.39463 12.5534 2.33317 12.405 2.33317 12.2503V4.66699H1.1665V3.50033H4.08317V1.75033C4.08317 1.59562 4.14463 1.44724 4.25402 1.33785C4.36342 1.22845 4.51179 1.16699 4.6665 1.16699H9.33317C9.48788 1.16699 9.63625 1.22845 9.74565 1.33785C9.85505 1.44724 9.9165 1.59562 9.9165 1.75033V3.50033ZM10.4998 4.66699H3.49984V11.667H10.4998V4.66699ZM5.24984 2.33366V3.50033H8.74984V2.33366H5.24984Z",
    fill: "#004894"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a0b52e55a7dd2d966ca2ce9ad720ec6b.svg";
export { ForwardRef as ReactComponent };